import { useIsInViewport } from 'hooks/useIsInViewport'
import { RefObject, useEffect } from 'react'

export default ({
  playHeadRef,
  scrollableContainerRef,
  isPlaying
}: {
  playHeadRef: RefObject<HTMLElement | null>
  scrollableContainerRef: RefObject<HTMLElement | null>
  isPlaying: boolean
}) => {
  const isInViewport = useIsInViewport(playHeadRef)

  useEffect(() => {
    if (!playHeadRef.current || !scrollableContainerRef.current) return

    if (!isInViewport && isPlaying) {
      scrollableContainerRef.current.scrollLeft =
        playHeadRef.current.offsetLeft -
        scrollableContainerRef.current.offsetLeft
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInViewport, isPlaying, playHeadRef])
}
